import { Component, Input } from '@angular/core'
import { AtomModule } from '../../atom/atom.module'

@Component({
  selector: 'app-no-items-found',
  templateUrl: './no-items-found.component.html',
  styleUrl: './no-items-found.component.less',
  standalone: true,
  imports: [AtomModule],
})
export class NoItemsFoundComponent {
  @Input() title = 'Oops, Nothing Found!'
}
